import IMAGE_1 from "../web_core/images/imgi_18_course-5.jpg";
import IMAGE_2 from "../web_core/images/imgi_21_course-6.jpg";
import IMAGE_3 from "../web_core/images/imgi_22_course-7.jpg";
import IMAGE_4 from "../web_core/images/imgi_23_course-8.jpg";
import IMAGE_5 from "../web_core/images/imgi_25_5.jpg";
import IMAGE_6 from "../web_core/images/imgi_36_news-4.jpg";
import IMAGE_7 from "../web_core/images/imgi_27_7.jpg";
import IMAGE_8 from "../web_core/images/imgi_47_4.jpg";
import IMAGE_9 from "../web_core/images/imgi_48_5.jpg";
import logo from "../web_core/images/onlineQuranlogo.png";
export const img = {
  IMAGE_1,
  IMAGE_2,
  IMAGE_3,
  IMAGE_4,
  IMAGE_5,
  IMAGE_6,
  IMAGE_7,
  IMAGE_8,
  IMAGE_9,
  logo,
};

export const courses = [
  { title: "Basic Quran Reading", image: img.IMAGE_1, weeks: "15 Weeks", lessons: 11, enrolled: "527", instructor: "Hafiz Bilal", instructorImg: img.logo, price: "30", duration: "30 min" },
  { title: "Tajweed Mastery", image: img.IMAGE_2, weeks: "15 Weeks", lessons: "12 Lessons", enrolled: "430", instructor: "Hafiz Qasim", instructorImg: img.logo, price: "30", duration: "30 min" },
  { title: "Seerah of Prophet ", image: img.IMAGE_3, weeks: "20 Weeks", lessons: "11 Lessons", enrolled: "467", instructor: "Hazrat Molana Bilal", instructorImg: img.logo, price: "35", duration: "30 min" },
  { title: "Hifz-e-Quran", image: img.IMAGE_5, weeks: "17 Weeks", lessons: "15 Lessons", enrolled: "468", instructor: "Hafiz Ijaz", instructorImg: img.logo, price: "50", duration: "30 min" },
  { title: "Dua & Supplications", image: img.IMAGE_4, weeks: "20 Weeks", lessons: "11 Lessons", enrolled: "581", instructor: "Qari Omer", instructorImg: img.logo, price: "35", duration: "1 hour" },
  { title: "Islamic History", image: img.IMAGE_6, weeks: "20 Weeks", lessons: "11 Lessons", enrolled: "479", instructor: "Qari Umair Farooqi", instructorImg: img.logo, price: "35", duration: "30 min" },
  { title: "Quran Tafseer", image: img.IMAGE_7, weeks: "20 Weeks", lessons: "11 Lessons", enrolled: "387", instructor: "Usman ", instructorImg: img.logo, price: "35", duration: "1 hour" },
  { title: "Islamic Studies", image: img.IMAGE_8, weeks: "20 Weeks", lessons: "11 Lessons", enrolled: "387", instructor: "Salman", instructorImg: img.logo, price: "35", duration: "30 min" },
  { title: "Quran Translation", image: img.IMAGE_9, weeks: "20 Weeks", lessons: "12 Lessons", enrolled: "593", instructor: "Yusuf", instructorImg: img.logo, price: "35", duration: "30 min" },
];

